<template>
  <ArendeSection :heading="heading">
    <ArendeItem
      v-for="(arende, index) in arendeList"
      :key="index"
      :arende="arende"
      :url="composeAnstalldarendeUrl(arende.id)"
    />
    <avtalat-button
      class="shrink self-center text-base"
      id="show-all-arenden"
      v-if="showButtonForAllArenden"
      v-on:click="showAllArenden"
      outlined
      >Visa alla <span class="lowercase">{{ heading }}</span></avtalat-button
    >
    <div v-if="noArenden">
      Det finns inga <span class="lowercase">{{ heading }}</span>
    </div>
  </ArendeSection>
</template>
<script setup lang="ts">
import { computed, reactive } from "vue";

import { composeAnstalldarendeUrl } from "@/common/utils/composeAnstalldArendeUrl";
import type { SimpleArende } from "@/types/simpleArende";

import ArendeItem from "./ArendeItem.vue";
import ArendeSection from "./ArendeSection.vue";

export type ArendenListProps = {
  heading?: string;
  arenden: SimpleArende[];
};

const props = defineProps<ArendenListProps>();

const state = reactive<{
  allArendenVisible: boolean;
}>({
  allArendenVisible: false,
});

const ARENDE_LIMIT = 3;

const showButtonForAllArenden = computed(() => {
  return !state.allArendenVisible && props.arenden.length > ARENDE_LIMIT;
});

const arendeList = computed(() => {
  return state.allArendenVisible
    ? props.arenden
    : props.arenden.slice(0, ARENDE_LIMIT);
});

const noArenden = computed(() => arendeList.value.length === 0);

const showAllArenden = () => {
  state.allArendenVisible = true;
};
</script>
